import Icons from 'app/components/Icon/iconFlagsSprite/IconFlagsSprite.svg';

interface FlagProps extends React.SVGAttributes<SVGSVGElement> {
  countryCode: string;
  style?: React.CSSProperties;
}

export const CountryFlag = ({ countryCode, style }: FlagProps) => {
  if (typeof countryCode !== 'string' || countryCode.toLowerCase() === 'ua') {
    return null;
  }

  const flagName = countryCode.toLowerCase();

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        ...style,
      }}
    >
      <svg width="20px" height="15px">
        <use xlinkHref={`${Icons}#icon-${flagName}`} />
      </svg>
    </div>
  );
};
